module.exports = __webpack_public_path__ + "static/media/male.4c354cc3.png";